const u = (path: string) => `https://www.tripinktattoo.vegas/wp-content/uploads/${path}`;

export const images = {
  iconSkills: u('2021/07/see_skills.svg'),
  iconSchedule: u('2021/07/schedule.svg'),
  iconArtists: u('2021/07/meet_artist.svg'),
  hero: u('2021/08/TIT-Header-Banner2-min.jpg'),
  vegasNeon: 'https://cdn.magicpatterns.com/patterns/generated-images/66d75ae2-c916-4f35-b1fd-f28337b9fac3.jpg',

  // Shop
  shirtMen: u('2021/08/tit_shirt_men-min.png'),
  shirtMenHover: u('2021/08/tit_men_shirt_hover.jpg'),
  shirtWomen: u('2021/08/tatoo_shirt_hover_comp-min.png'),
  shirtWomenHover: u('2021/08/tit_women_shirt_hover-1.jpg'),
  giftCertificate: u('2021/08/shop_gift_certificate.jpg'),
  giftCertificateHover: u('2021/08/shop_gift_certificate_hvoer.jpg'),
  tattooDeposit: u('2021/07/Tattoo-Deposit.jpg'),
  shirtsGlasses: u('2021/07/tattoo-shirts-glasses-shop-Las-Vegas-Trip-Ink.jpg'),
  logoSticker: u('2021/07/Trip-Ink-Tattoo-Las-Vegas-Logo.jpg'),
  moodys: u('2019/06/Ivan-Moody-Medicinals-CBD-Products-Las-Vegas-Trip-Ink-Tattoo.jpeg'),
  blackFlys: u('2017/07/Black-Flys-Distribution-Trip-Ink-Tattoo-Company-Las-Vegas-Nevada.jpg'),
  shirt: u('2021/08/tit_shirt_men-min.png'),

  // Artists
  rick: u('2017/04/Rick-Trip-Tattoo-Artist-Las-Vegas-Nevada-Trip-Ink-Tattoo.jpg'),
  sophia: 'https://cdn.magicpatterns.com/patterns/generated-images/8da9ab58-2575-47df-8a58-b9a307a637ab.jpg',
  casso: 'https://cdn.magicpatterns.com/patterns/generated-images/eeb7fe58-ca6c-42c8-98ca-2aabc7b5f07b.jpg',
  rich: 'https://cdn.magicpatterns.com/patterns/generated-images/17e6909c-90a5-4fee-ba67-ef3e5d2568a5.jpg',

  // Real tattoo photos used as page and blog backdrops
  skull: u('2021/07/best-skull-tattoo-las-vegas-trip-ink-tattoo-2-1.jpeg'),
  snake: u('2021/08/real-snake-arm-tattoo-las-vegas-trip-ink-tattoo-nevada.jpg'),
  sunflower: u('2021/10/sunflower-tattoo-artist-las-vegas-trip-ink-tattoo.jpg'),
  dolphin: u('2021/07/dolphin-tattoo-las-vegas-trip-ink-tattoo-1.jpg'),
  cupcake: u('2021/07/lion-and-rose-tattoo-las-vegas-rick-trip-portfolio-110-1.jpg'),
  knight: u('2021/07/tattoo-dragon-beauty-by-trip-ink-tattoo-las-vegas-1.jpg'),
  heart: u('2021/07/wings-roses-jewel-heart-tattoo-by-artist-Rain-las-vegas-trip-ink-tattoo-1.png'),
  fish: u('2021/07/coloful-rose-tattoo-trip-ink-tattoo-las-vegas-1.jpg'),
};
